import { Store } from "pullstate";


export const DarkModeStore = new Store({
    themeMode:false
   });
 
 